<template>
    <v-autocomplete
        v-model="select"
        @input="HandleInput"
        :items="items"
        :search-input.sync="search"
        :item-text="DisplayName"
        :readonly="readonly"
        :clearable="!readonly"
        :label="label || $t('Medicament')"
        :disabled="disabled"
        :rules="rules"
        return-object
        no-filter
        flat
        hide-no-data
        dense
        outlined
        hide-details="auto"
        :style="{ 'width': width ? width + 'px' : 'auto' }"
    ></v-autocomplete>
</template>

<script>
import medicamentService from '@/service/medicament-service';

export default {
    props: {
        value: Number,
        label: String,
        readonly: Boolean,
        disabled: Boolean,
        source: Number,
        includeDeleted: Boolean,
        width: Number,
        withBrunvaAccess: Boolean,
        departmentCode: Number,
        unitType: Number,
        onlyEhrMedicaments: Boolean,
        hasMohProductId: Boolean,
        productGeneric: String,
        checkWithPharmacy: Boolean,
        patientPersonalNumber: String,
        historyCode: Number,
        datetimeForDepartmentDetermination: String,
        rules: {
            required: false,
            default: () => []
        },
    },
    data() {
        return {
            items: [],
            search: null,
            select: null,
            timer: null,
            getDataAbort: null,
        };
    },
    mounted() {
        if (this.value) {
            this.SetSelected(this.value);
        }
    },
    watch: {
        search(value, oldValue) {
            if (value !== oldValue) {
                let id = this.select
                    ? this.source === 2 ? this.select.MohProductId : this.select.Code
                    : null;
                if (
                    value !== id &&
                    value !== this.DisplayName(this.select)
                ) {
                    clearTimeout(this.timer);
                    this.items = [];
                    if (this.getDataAbort) {
                        this.getDataAbort.abort();
                    }
                    if (value) {
                        this.timer = setTimeout(
                            () => this.QuerySelections(value),
                            300
                        );
                    }
                }
            }
        },
        value(val) {
            if (!val) {
                this.search = null;
                this.select = null;
                this.items = [];
            } else {
                this.SetSelected(val);
            }
        },
    },
    methods: {
        GetData(filter, callback) {
            if (this.getDataAbort) {
                this.getDataAbort.abort();
                this.items = [];
            }
            this.getDataAbort = new AbortController();
            let updatedFilter = {
                ...filter,
                PatientPId: this.patientPersonalNumber
            };
            if (this.source && this.source > 0) {
                updatedFilter.Source = this.source;
            }
            if (this.includeDeleted) {
                updatedFilter.IncludeDeleted = true;
            }
            if (this.withBrunvaAccess || this.withBrunvaAccess === false) {
                updatedFilter.withBrunvaAccess = this.withBrunvaAccess;
            }
            if (this.departmentCode || this.departmentCode === false) {
                updatedFilter.departmentCode = this.departmentCode;
            }
            if (this.historyCode) {
                updatedFilter.HistoryCode = this.historyCode;
            }
            if (this.datetimeForDepartmentDetermination) {
                updatedFilter.DatetimeForDepartmentDetermination = this.datetimeForDepartmentDetermination;
            }
            updatedFilter.UnitType = this.unitType || null;
            if (this.onlyEhrMedicaments) {
                updatedFilter.OnlyEhrMedicaments = true;
            }
            if (!filter.usingSearch) {
                updatedFilter.withBrunvaAccess = false;
                updatedFilter.departmentCode = null;
                updatedFilter.OnlyEhrMedicaments = false;
            }
            if (this.hasMohProductId) {
                updatedFilter.MohProductId_Not = 0;
            }
            if (this.productGeneric) {
                updatedFilter.ProductGeneric = this.productGeneric;
            }
            if (this.checkWithPharmacy) {
                updatedFilter.CheckWithPharmacy = true;
            }

            medicamentService
                .getData(
                    1,
                    20,
                    updatedFilter,
                    this.getDataAbort && this.getDataAbort.signal
                )
                .then((response) => callback(response))
                .finally(() => {
                    this.getDataAbort = null;
                });
        },
        QuerySelections(search) {
            let filter = {};
            if (/^\d+$/.test(search)) {
                if (this.source === 2) {
                    filter.CodeOrMohProductId = +search;
                } else {
                    filter.Code = +search;
                }
            } else {
                if (this.source === 2) {
                    filter.ContainsTexts = search;
                } else {
                    filter.Name_Contains = search;
                }
            }
            this.GetData({...filter, usingSearch: true}, (resp) => (this.items = resp.data));
        },
        HandleInput() {
            let id = this.select
                ? this.source === 2 ? this.select.MohProductId : this.select.Code
                : null;
            this.$emit('input', id);
            this.$emit('change', this.select);
            this.HandleUnit();
        },
        HandleUnit() {
            let unit = this.select
                ? {
                    id: this.select.UnitId || null,
                    name: this.select.UnitName || null,
                    type: this.select.UnitType || null,
                    rate: this.select.UnitRate || null,
                    quantity: this.select.UnitQuantity || null,
                    convertUnits: this.select.ConvertUnits || null,
                } : null;
            this.$emit('unit', unit);
        },
        SetSelected(value) {
            let id = this.select
                ? this.source === 2 ? this.select.MohProductId : this.select.Code
                : null;
            if (value && value !== id) {
                this.GetData({ Code: value }, (response) => {
                    var data = response.data.filter((d) => (this.source === 2 ? d.MohProductId : d.Code) == value);
                    if (data.length > 0) {
                        this.items = data;
                        this.select = data[0];
                        this.HandleUnit();
                    }
                });
            }
        },
        DisplayName(med) {
            if (med) {
                let currentQuantity = med.CurrentQuantity > 0
                    ? ` (ნაშ.: ${med.CurrentQuantity})`
                    : '';
                if (this.source === 2) {
                    return `[${med.MohProductId}] ${med.Name} - ${med.OtherDetailsGeo}${currentQuantity}`;
                }
                return `[${med.Code}] ${med.Name}${currentQuantity}`;
            }
            return null;
        },
    },
};
</script>

<style>
</style>
